module.exports = __webpack_public_path__ + "img/s00141.03995caf.jpg";